import { Directive, ElementRef, Input, OnChanges, SimpleChanges } from '@angular/core';

@Directive({
  selector: '[CurrencySvg]',
  standalone: true
})
export class CurrencySvgDirective implements OnChanges {
  @Input() color: string;   // Color input for the icon
  @Input() stroke: string;   // stroke input for the icon
  @Input() width: string = '18';  // Default width is 18px
  @Input() height: string = '18'; // Default height is 18px
  @Input() customLang:'ar'|'en';
  @Input() currencyId: string | number;
  @Input() currencyNameAr: string = '';
  @Input() currencyNameEn: string = '';

  private icons = {
    '1028': `<svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1124.14 1256.39"><defs><style>.cls-1 {fill: #231f20;}</style></defs><path class="cls-1" d="M699.62,1113.02h0c-20.06,44.48-33.32,92.75-38.4,143.37l424.51-90.24c20.06-44.47,33.31-92.75,38.4-143.37l-424.51,90.24Z"/><path class="cls-1" d="M1085.73,895.8c20.06-44.47,33.32-92.75,38.4-143.37l-330.68,70.33v-135.2l292.27-62.11c20.06-44.47,33.32-92.75,38.4-143.37l-330.68,70.27V66.13c-50.67,28.45-95.67,66.32-132.25,110.99v403.35l-132.25,28.11V0c-50.67,28.44-95.67,66.32-132.25,110.99v525.69l-295.91,62.88c-20.06,44.47-33.33,92.75-38.42,143.37l334.33-71.05v170.26l-358.3,76.14c-20.06,44.47-33.32,92.75-38.4,143.37l375.04-79.7c30.53-6.35,56.77-24.4,73.83-49.24l68.78-101.97v-.02c7.14-10.55,11.3-23.27,11.3-36.97v-149.98l132.25-28.11v270.4l424.53-90.28Z"/></svg>`,

  }

  // private icons = {
  //   'SAR': `<svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1124.14 1256.39"><defs><style>.cls-1 {fill: #231f20;}</style></defs><path class="cls-1" d="M699.62,1113.02h0c-20.06,44.48-33.32,92.75-38.4,143.37l424.51-90.24c20.06-44.47,33.31-92.75,38.4-143.37l-424.51,90.24Z"/><path class="cls-1" d="M1085.73,895.8c20.06-44.47,33.32-92.75,38.4-143.37l-330.68,70.33v-135.2l292.27-62.11c20.06-44.47,33.32-92.75,38.4-143.37l-330.68,70.27V66.13c-50.67,28.45-95.67,66.32-132.25,110.99v403.35l-132.25,28.11V0c-50.67,28.44-95.67,66.32-132.25,110.99v525.69l-295.91,62.88c-20.06,44.47-33.33,92.75-38.42,143.37l334.33-71.05v170.26l-358.3,76.14c-20.06,44.47-33.32,92.75-38.4,143.37l375.04-79.7c30.53-6.35,56.77-24.4,73.83-49.24l68.78-101.97v-.02c7.14-10.55,11.3-23.27,11.3-36.97v-149.98l132.25-28.11v270.4l424.53-90.28Z"/></svg>`,
  //   'ر.س': `<svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1124.14 1256.39"><defs><style>.cls-1 {fill: #231f20;}</style></defs><path class="cls-1" d="M699.62,1113.02h0c-20.06,44.48-33.32,92.75-38.4,143.37l424.51-90.24c20.06-44.47,33.31-92.75,38.4-143.37l-424.51,90.24Z"/><path class="cls-1" d="M1085.73,895.8c20.06-44.47,33.32-92.75,38.4-143.37l-330.68,70.33v-135.2l292.27-62.11c20.06-44.47,33.32-92.75,38.4-143.37l-330.68,70.27V66.13c-50.67,28.45-95.67,66.32-132.25,110.99v403.35l-132.25,28.11V0c-50.67,28.44-95.67,66.32-132.25,110.99v525.69l-295.91,62.88c-20.06,44.47-33.33,92.75-38.42,143.37l334.33-71.05v170.26l-358.3,76.14c-20.06,44.47-33.32,92.75-38.4,143.37l375.04-79.7c30.53-6.35,56.77-24.4,73.83-49.24l68.78-101.97v-.02c7.14-10.55,11.3-23.27,11.3-36.97v-149.98l132.25-28.11v270.4l424.53-90.28Z"/></svg>`
  // }

  constructor(private el: ElementRef) { }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['color']) this.updateColor();
    if (changes['stroke']) this.updatStroke();
    if (changes['width'] || changes['height']) this.updateSize();
    if (changes['customLang'] || changes['currencyId']) this.updateIcon();
  }

  ngOnInit(): void {
    this.updateIcon();
  }

  private updateIcon(): void {
    // const currencyId = this.sharedService.AccountCurrency?.Currency?.Id ?? this.currencyId;
    // const icon = this.icons[currencyId];
    // if (icon) {
    //   this.el.nativeElement.innerHTML = icon;
    //   this.updateColor(); // Ensure color is applied after updating icon
    //   this.updatStroke(); // Ensure color is applied after updating icon
    //   this.updateSize();  // Ensure size is applied after updating icon
    // } else {
    //   const language = this.customLang || this.sharedService.Lang;
    //   const currencyLabel = language === 'ar' ? (this.sharedService.CurrencyNameAr ?? this.currencyNameAr) : (this.sharedService.CurrencyNameEn ?? this.currencyNameEn);
    //   this.el.nativeElement.innerHTML = currencyLabel;
    // }

    this.el.nativeElement.innerHTML = this.icons['1028'];
    this.updateColor(); // Ensure color is applied after updating icon
    this.updatStroke(); // Ensure color is applied after updating icon
    this.updateSize();  // Ensure size is applied after updating icon
  }

  private updateColor(): void {
    if (this.color) {
      const svg = this.el.nativeElement.querySelector('svg');
      if (svg) {
        const paths = svg.querySelectorAll('path');
        paths.forEach((path: HTMLElement) => {
          path.setAttribute('fill', this.color); // Apply color to each path
        });
      }
    }
  }
  private updatStroke(): void {
    if (this.stroke) {
      const svg = this.el.nativeElement.querySelector('svg');
      if (svg) {
        const paths = svg.querySelectorAll('path');
        paths.forEach((path: HTMLElement) => {
          path.setAttribute('stroke', this.stroke); // Apply stroke to each path
        });
      }
    }
  }

  private updateSize(): void {
    const svg = this.el.nativeElement.querySelector('svg');
    if (svg && this.width && this.height) {
      svg.setAttribute('width', this.width);   // Set width dynamically
      svg.setAttribute('height', this.height);  // Set height dynamically
    }
  }
}
